import * as React from 'react';
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { makeStyles, MuiThemeProvider } from '@material-ui/core/styles';
import {
    Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow, TableSortLabel, 
    Grid, Button, InputAdornment, LinearProgress, TextField, IconButton, Checkbox, Paper,
    Dialog, DialogContent, CheckboxProps, Box
} from '@material-ui/core';
//import { CheckboxProps } from "@material-ui/core/Checkbox";
import SearchIcon from '@material-ui/icons/Search';
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import '../../../style/UserStyleSheet.css';
import api from '../../../store/api';
import throttle from 'lodash/throttle';
import SignOutUserDialog from '../../shared/SignOutUserDialog';
import { FlameIcon } from '../../../assets/iconComponents/Icons';
import eventNames from '../../../store/signalr/eventNames';
import { addTaskForEvent, removeTaskForEvent } from '../../../store/signalr/tasksForEvents';
import { format, startOfMonth, endOfMonth } from 'date-fns';
import { CloudDownloadIcon } from "../../../assets/iconComponents/Icons";
import CloseIcon from "@material-ui/icons/Close";
import { Typography } from "@material-ui/core";
import { CSVLink } from "react-csv";
import clsx from "clsx";
import { useStyles } from './styles';
import Navbar from "../../shared/Navbar";
import SubHeader from './SubHeader';
import { RootState } from "../../../store/rootReducer";
import theme from "../../../components/shared/theme";
import { getDataFromStorage, setDataToStorage } from "../../../common/sessionStorageHelpers";
import { PCRReviewStatus } from "../../../common/types";
import DateFnsUtils from '@date-io/date-fns';
import { KeyboardDatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import HospitalPopup from '../../popup/HospitalPopup';
import { filterLocationForPopup, getLocationsDataForPopup } from '../../popup/hospitalPopupHelpers';
import ISelectItem from '../../popup/types/ISelectItem';
import { filterCustomerForPopup, getCustomerDataForPopup } from '../../popup/customerPopupHelpers';
import CustomerPopup from '../../popup/CustomerPopup';
import { forEach } from 'lodash';
import PCRObservationChartPDF from '../../patientCareRecord/SubFormWidgets/PCRObservationChartPDF';

const persistName = "PCR";
const getData = (value = "") => getDataFromStorage(persistName, value);
const setData = (key: string, value: any) => setDataToStorage(persistName, key, value);

interface PCR {
    id:number,
    createdOn: string | Date | number,
    pcrType: string,
    surName: string,
    givenName: string,
    dob: string | Date | number,
    gender: string,
    mrn: string,
    reviewStatus: number | null
};
interface PCRReviewStatusCount {
    countAll:Number|null,
    countNotApplicable :Number|null,
    countReviewPending:Number|null,
    countInReview:Number|null,
    countReviewed:Number|null,
    countFlagged:Number|null,
    countPendingCGReview:Number|null,
    countInCGReview:Number|null,
    countCGReviewed:Number|null,
    countCGFlagged:Number|null
}
interface IColumnList {
    columnName: string;
    columnCaption: string;
    selected: boolean;
}
  
const useStylesCheckBox = makeStyles({
    root: {
      "&:hover": {
        backgroundColor: "transparent",
      },
    },
    icon: {
      borderRadius: 3,
      width: 15,
      height: 15,
      backgroundColor: "#ECECEC",
    },
    checkboxInput: {
      '&.MuiCheckbox-root': {
          '&:not(.Mui-checked) .MuiIconButton-label:after': {
              backgroundColor: "#EFF0F2",
          },
          '& .MuiIconButton-label svg.MuiSvgIcon-root': {
              fill: "#EFF0F2",
          },
          '&.whiteBg': {
              '&:not(.Mui-checked) .MuiIconButton-label:after': {
                  backgroundColor: "#FFFFFF",
              },
              '& .MuiIconButton-label svg.MuiSvgIcon-root': {
                  fill: "#FFFFFF",
              },
          },
      },
  },
    checkedIcon: {
      backgroundColor: "#ECECEC",
      "&:before": {
        display: "block",
        width: 15,
        height: 15,
        backgroundImage:
          "url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3E%3Cpath" +
          " fill-rule='evenodd' clip-rule='evenodd' d='M12 5c-.28 0-.53.11-.71.29L7 9.59l-2.29-2.3a1.003 " +
          "1.003 0 00-1.42 1.42l3 3c.18.18.43.29.71.29s.53-.11.71-.29l5-5A1.003 1.003 0 0012 5z' fill='%2303090E'/%3E%3C/svg%3E\")",
        content: '""',
      },
    },
});

const reviewHeadCells = [
  { id: 'CreatedOn', numeric: false, disablePadding: true, label: 'Submitted', width:'15%' },
  { id: 'PCRType', numeric: false, disablePadding: false, label: 'Type',width:'15%' },
  { id: 'SurName', numeric: false, disablePadding: false, label: 'Last Name',width:'12%' },
  { id: 'GivenName', numeric: false, disablePadding: false, label: 'First Name', width:'12%' },
  { id: 'DOB', numeric: false, disablePadding: false, label: 'DOB', width: '10%' },
  { id: 'Gender', numeric: false, disablePadding: false, label: 'Gender', width: '10%' },
  { id: 'MRN', numeric: false, disablePadding: false, label: 'MRN', width: '10%' },
  { id: 'ReviewStatus', numeric: false, disablePadding: false, label: 'Review Status', width: '16%' },
];
const nonReviewheadCells = [
  { id: 'CreatedOn', numeric: false, disablePadding: true, label: 'Submitted', width:'15%' },
  { id: 'PCRType', numeric: false, disablePadding: false, label: 'Type',width:'15%' },
  { id: 'SurName', numeric: false, disablePadding: false, label: 'Last Name',width:'12%' },
  { id: 'GivenName', numeric: false, disablePadding: false, label: 'First Name', width:'12%' },
  { id: 'DOB', numeric: false, disablePadding: false, label: 'DOB', width: '10%' },
  { id: 'Gender', numeric: false, disablePadding: false, label: 'Gender', width: '10%' },
  { id: 'MRN', numeric: false, disablePadding: false, label: 'MRN', width: '10%' },
  { id: 'MRN', numeric: false, disablePadding: false, label: '', width: '10%' },
];
const ActivityIcon = (events: null | number) => {
 
    if (!events || (events >= 0 && events <= 10)) {
        return;
    }

    if (events > 10 && events <= 100) {
        return (
            <div style={{display: 'flex'}} >
                <FlameIcon height={30} width={30} />
            </div>
        )
    }
    if (events > 100 && events <= 1000) {
        return (
            <div style={{ display: 'flex' }} >
                <FlameIcon height={30} width={30} />
                <FlameIcon height={30} width={30} />
            </div>
        )
    }
    if (events > 1000 ) {
        return (
            <div style={{ display: 'flex' }} >
                <FlameIcon height={30} width={30} />
                <FlameIcon height={30} width={30} />
                <FlameIcon height={30} width={30} />
            </div>
        )
    }
}

const componentTaskId = "viewPCRWidget";

interface IUserData {
    givenName: string;
    surName: string;
    email: string;
    role: string;
    IsAdmin: boolean;
    exp: number;
    location: string;
    ward: string;
};
interface IAuthState {
    isAuthenticated?: boolean;
    token: string | null;
    userName: string | null;
    data: IUserData | null;
    sessionExpired: boolean;
};
const getRoles = (authStore: IAuthState) => {
    const roles = {
      isAdmin: authStore?.data?.IsAdmin || false,
      SMADriver: authStore?.data ? (authStore?.data?.role?.indexOf("SMA Driver") >= 0 ? true : false) : false,
      CustomerDriver: authStore?.data ? (authStore?.data?.role?.indexOf("Customer Driver") >= 0 ? true : false) : false,
      hospitalAdministrator: authStore?.data?.role ? (authStore?.data?.role?.indexOf("Hospital Administrator") >= 0 ? true : false) : false,
      bookingCoordinator: authStore?.data?.role ? (authStore?.data?.role?.indexOf("Booking Coordinator") >= 0 ? true : false) : false,
      nurseStation: authStore?.data?.role
        ? authStore?.data?.role?.indexOf("Booking Coordinator") >= 0 || authStore?.data?.role?.indexOf("Ward") >= 0
          ? true
          : false
        : false, //&&
      SMAViewTransferHistory: authStore?.data?.role ? authStore?.data?.role?.indexOf("SMAViewTransferHistory") >= 0 : false,
        ViewCustomerTransferHistory: authStore?.data?.role ? authStore?.data?.role?.indexOf("ViewCustomerTransferHistory") >= 0 : false,
        ViewPCR: authStore?.data?.role ? (authStore?.data?.role?.indexOf("ViewPCR") >= 0 || authStore?.data?.role?.indexOf("SMAViewPCR") >= 0) : false,
    };
    return {
      assignText: roles.isAdmin ? "Assign" : roles.SMADriver ? "Assign To Me" : "",
      subHeader: roles.isAdmin || roles.SMAViewTransferHistory || roles.ViewCustomerTransferHistory || roles.bookingCoordinator || roles.nurseStation || roles.ViewPCR ? true : false,
      hospitalSelectArrow: roles.isAdmin ? true : false,
      wardSwitch: roles.nurseStation && !roles.isAdmin,
      transerSwitch: roles.SMADriver || roles.isAdmin ? true : false,
      transerSwitchRightText: roles.isAdmin ? "Unassigned" : roles.SMADriver ? "Assigned To Me" : "",
      scheduleTransfer: roles.isAdmin || (roles.bookingCoordinator && !roles.nurseStation) ? true : false,
      hospitalSelectNavBar: roles.SMADriver && !roles.isAdmin ? true : false,
      transferCheckboxes: roles.SMADriver && !roles.isAdmin,
      isSMADriver: roles.SMADriver && !roles.isAdmin,
      isAdmin: roles.isAdmin,
      adminNavbar: roles.isAdmin,
      locationOval: roles.isAdmin,
      isHospitalAdmin: roles.hospitalAdministrator,
    };
};

function ViewPCRWidget(props:any): JSX.Element {
    const classes = useStyles();
    const { authStore } = useSelector((state: RootState) => state);
    const show = getRoles(authStore);   
    const [userList, setUserList] = React.useState<PCR[]>([]);
    const [currentStatus, setCurrentStatus] = React.useState(localStorage.getItem("ViewPCR:CurrentStatus") !=null ? Number.parseInt(localStorage.getItem("ViewPCR:CurrentStatus") ?? "-1") : -1);
    const [order, setOrder] = React.useState(localStorage.getItem("ViewPCR:SortDirection") != null ? localStorage.getItem("ViewPCR:SortDirection") : 'desc');
    const [searchKey, setSearchKey] = React.useState(localStorage.getItem("ViewPCR:Keyword")!=null ? localStorage.getItem("ViewPCR:Keyword") : "");
    const popState = React.useState(false);
    const [dateDialog, setDateDialog] = React.useState<string | null>(null);
    const [selectedCustomer, setSelectedCustomer] = React.useState<any>("All Customers");
    // const [startDay, setStartDay] = React.useState(getData("startDay") ? new Date(getData("startDay")) : startOfMonth(new Date()));
    // const [endDay, setEndDay] = React.useState(getData("endDay") ? new Date(getData("endDay")) : endOfMonth(new Date()));
     const [startDay, setStartDay] = React.useState(localStorage.getItem("ViewPCR:StartDate")!=null ? new Date(localStorage.getItem("ViewPCR:StartDate")??"") : startOfMonth(new Date()));
    const [endDay, setEndDay] = React.useState(localStorage.getItem("ViewPCR:EndDate")!=null ? new Date(localStorage.getItem("ViewPCR:EndDate")??"") : endOfMonth(new Date()));
   
    const [orderBy, setOrderBy] = React.useState(localStorage.getItem("ViewPCR:SortColumn") != null ? localStorage.getItem("ViewPCR:SortColumn") : 'CreatedOn');
    const [selected, setSelected] = React.useState('');
    const [page, setPage] = React.useState(0);
    const [doLoad, setDoLoad] = React.useState<number>(0);
  
    const [recordCount, setRecordCount] = React.useState(0);
    const [reviewUser, setReviewUser] = React.useState<boolean>(false);
    const headCells = reviewUser==true ? reviewHeadCells : nonReviewheadCells;
    const [rowsPerPage, setRowsPerPage] = React.useState(20);
    const [searchText, setSearchText] = React.useState('');
    const [showAllUsers, setShowAllUsers] = React.useState(true);
  
    const [loading, setLoading] = React.useState(false);
    const history = useHistory();
    const refOrder = React.useRef('desc');
    const refOrderBy = React.useRef('CreatedOn');
    const refSearchText = React.useRef('');
    const refPage = React.useRef(0);
    const refStatus = React.useRef(-1);
    const [signoutDialog, setSignoutDialog] = React.useState(false);
    const [signoutUserId, setSignoutUserId] = React.useState('');
    const [showDownloadCSVModal, setShowDownloadCSVModal] = React.useState(false);
    const [saveSelection, setSaveSelection] = React.useState(false);
    const [csvDataSet, setCsvDataSet] = React.useState<any[]>([]);
    const [countReviewStatus, setCountReviewStatus]=React.useState<PCRReviewStatusCount>();
    const columnList = React.useState<IColumnList[]>([]);
    
    const pageNumber = props?.page?.page  ?? 0;
    const[isBack,setisBack] = React.useState(Boolean(props?.page?.isBack)  ?? false);
    const[customerids,setcustomerids] = React.useState("");
    const [csvReport, setCsvReport] = React.useState<any>({
        data: [],
        headers: [],
        filename: "Transfers.csv",
      });
    const whenRefreshUsersDo = () =>  getAllPCR(refPage.current, refSearchText.current, refOrder.current, refOrderBy.current, refStatus.current,startDay,endDay,customerids);
    const locationState = React.useState<ISelectItem[]>([]);
    const customerState = React.useState<ISelectItem[]>([]);
    const [selectedLocations, setSelectedLocations] = React.useState<any>(getData("selectedLocations") || []);
    React.useEffect(() => {
        addTaskForEvent(eventNames.refreshUsers, componentTaskId, whenRefreshUsersDo);
        return () => {
            removeTaskForEvent(eventNames.refreshUsers, componentTaskId);       
        }
       
    }, [whenRefreshUsersDo]);

   React.useMemo(() => {
    localStorage.setItem("ViewPCR:StartDate",startDay.toString());
    },[startDay]);

    React.useMemo(() => {
      localStorage.setItem("ViewPCR:EndDate",endDay.toString());
    },[endDay]);

    React.useEffect(() => {
        if (!signoutDialog) {
          if (doLoad!=0)
          setDoLoad(a => a+1);
        }
    }, [signoutDialog]);

    React.useEffect(() => {
        refPage.current = page;
        refSearchText.current = searchText;
        refOrder.current = order ?? "desc";
        refOrderBy.current = orderBy ?? "CreatedOn";
    }, [page, searchText, order, orderBy]);

    React.useEffect(() => {
        refPage.current = page;
        refSearchText.current = searchText;
        refOrder.current = order ?? "desc";
        refOrderBy.current = orderBy ?? "CreatedOn";
    }, [page, searchText, order, orderBy]);

    React.useEffect(() => {
      setSelectedLocations([])
      getCustomerData();
  }, []);

    const handlePickerDateChange = (date: Date | null) => {
        if (date == null) return;
        localStorage.removeItem("ViewPCR:StartDate");
        localStorage.removeItem("ViewPCR:EndDate");
        if (dateDialog == "endDay") {
            setEndDay(date);
            localStorage.setItem("ViewPCR:EndDate", date.toString());
        } else {
            localStorage.setItem("ViewPCR:StartDate", date.toString());
            setStartDay(date);
        }
        searchDatewisePCR("")
        setDateDialog(null);
    };   

    React.useEffect(() => {
    }, [userList]);

    React.useEffect(() => {
      if (doLoad!=0){
        if (page===0){
          setDoLoad(a => a+1);
        }
        else {
          setPage(0);
        }
        setisBack(false);
      }
    }, [currentStatus,startDay,endDay,searchKey, order, orderBy]);

    React.useEffect(() => {
      if (doLoad!=0)
      setDoLoad(a => a+1);
    }, [page]);
  
  React.useEffect(() => {
    let _allowrequest: boolean = false;
    if (show.isAdmin == true)
      _allowrequest = true;
    else if (show.isAdmin == false && (selectedLocations.length != 0 || getData("selectedLocations")?.length != 0))
      _allowrequest = true;
    if (_allowrequest ) {
        // setPage(0);
      var customer=""
      if (selectedLocations.length > 0) {
        selectedLocations.forEach((element: any, index: any) => {
          if (index === 0) {
            customer = element.toString();
          }
          else {
            customer = customer + "," + element.toString();

          }
        });
      }
      else if (getData("selectedLocations")?.length > 0) {
        getData("selectedLocations")?.forEach((element: any, index: any) => {
          if (index === 0) {
            customer = element.toString();
          }
          else {
            customer = customer + "," + element.toString();

          }
        });
      }
      
      setcustomerids(customer);
      getAllPCRs(0, searchKey ?? "", order, orderBy, currentStatus, startDay, endDay,customer);
    }
  }, [selectedCustomer])
    React.useEffect(() => {
      try {
        if(caches != undefined) {
          caches.keys().then((names) => {
            names.forEach((name) => {
                if(name.includes("/api/PCR/")) caches.delete(name);
            });
          });
        }
      } catch (error) {
        console.log("Error in reading cache.");
      }

      let _allowrequest: boolean = false;
      if (show.isAdmin == true)
        _allowrequest = true;
      else if (show.isAdmin == false && (selectedLocations.length != 0 || getData("selectedLocations")?.length != 0))
        _allowrequest = true;
      var customer=""
      if (_allowrequest && selectedLocations.length > 0) {
        selectedLocations.forEach((element: any, index: any) => {
          if (index === 0) {
            customer = element.toString();
          }
          else {
            customer = customer + "," + element.toString();

          }
        });
        setcustomerids(customer);
      }
      else if (_allowrequest && getData("selectedLocations")?.length > 0) {
        getData("selectedLocations").forEach((element: any, index: any) => {
          if (index === 0) {
            customer = element.toString();
          }
          else {
            customer = customer + "," + element.toString();

          }
        });
        setcustomerids(customer);
      }
      
      if (doLoad===0){
        setDoLoad(a => a+1);
      }
      else{
        getAllPCR(page+1, searchKey ?? "", order, orderBy,currentStatus,startDay,endDay,customer);
      }
    }, [doLoad]);

    React.useEffect(() => {
      if(isBack){
        var pNumber = Number(pageNumber) > 0 ? Number(pageNumber) - 1 : 0;
        setPage(pNumber);
      }
      else{
        setPage(0)
      }
      
    }, [pageNumber,setPage,isBack,setisBack]);

    const getCustomerData = async (): Promise<void> => {
      await getCustomerDataForPopup(customerState, setSelectedCustomer, setSelectedLocations, selectedLocations, persistName);
    };
    const filterCustomer = () => {
      filterCustomerForPopup(customerState, setSelectedCustomer, setSelectedLocations, persistName);
      setisBack(false);
    };
    //Get All Users
    const getAllPCR = React.useMemo(() => throttle(async (updatePageNumber: any, keyword: string, sortOrder: any, sortColumn: any,status :any|null,startDay :any|null,endDay :any|null,customerids:any): Promise<void> => {
      setLoading(true);
      localStorage.setItem("ViewPCR:PageNumber",(updatePageNumber ? updatePageNumber-1 : page-1).toString());
      localStorage.setItem("ViewPCR:StartDate",startDay.toString());
      localStorage.setItem("ViewPCR:EndDate",endDay.toString());
      localStorage.setItem("ViewPCR:Keyword",keyword.toString());
      localStorage.setItem("ViewPCR:SortColumn",sortColumn.toString());
      localStorage.setItem("ViewPCR:SortDirection",sortOrder.toString());
      localStorage.setItem("ViewPCR:CurrentStatus",status!=null ? status : currentStatus);
      
      const _res = await api.searchPCRByNameCount('searchstr=' + keyword + '&pagenumber=' + (updatePageNumber ? updatePageNumber : page) + 
      '&pagesize=20&sortcolumn=' + sortColumn + '&sortdirection=' + sortOrder + `&showAll=${showAllUsers}` +
       '&startdate=' + format(startDay, "yyyy-MM-dd") + '&enddate=' + format(endDay, "yyyy-MM-dd")+
       "&version="+Math.random()+Math.random()+Math.random()+"&CustomerId="+customerids);
      if (_res !== null && _res.data !== null && _res.data.model !== null) {
          setCountReviewStatus((prevState) => ({
            ...prevState,
            countAll: _res.data.model.all,
            countNotApplicable: _res.data.model.notApplicable,
            countReviewPending: _res.data.model.reviewPending,
            countInReview: _res.data.model.inReview,
            countReviewed: _res.data.model.reviewed,
            countFlagged: _res.data.model.flagged,
            countPendingCGReview: _res.data.model.pendingCGReview,
            countInCGReview: _res.data.model.inCGReview,
            countCGReviewed: _res.data.model.cgReviewed,
            countCGFlagged: _res.data.model.cgFlagged,
          }));
          setReviewUser(_res.data.model.isReviewUser);
          if (status==1 || status==2 || status==5 || status==6){
            startDay=new Date();
            startDay.setFullYear(startDay.getFullYear() - 10);
            endDay=new Date();
            endDay.setFullYear(endDay.getFullYear() + 10);
          }
          const _innerRes = await api.searchPCRByName('searchstr=' + keyword + '&pagenumber=' + (updatePageNumber ? updatePageNumber : page) + 
          '&pagesize=20&sortcolumn=' + sortColumn + '&sortdirection=' + sortOrder + `&showAll=${showAllUsers}` +
           '&startdate=' + format(startDay, "yyyy-MM-dd") + '&enddate=' + format(endDay, "yyyy-MM-dd")+ 
           '&currentstatus=' + (status!=null ? status : currentStatus)+ 
           '&reviewuser=' +_res.data.model.isReviewUser+"&version="+Math.random()+Math.random()+Math.random()+"&CustomerId="+customerids);
          if (_innerRes !== null && _innerRes.data !== null && _innerRes.data.model !== null) {
            if (_innerRes.data.itemsCount > 0 && updatePageNumber >= page) {
                setUserList(_innerRes.data.model);
                setRecordCount(_innerRes.data.itemsCount);
            } else if (_innerRes.data.itemsCount > 0 && (page == 0 || page == 1)) {
                setUserList(_innerRes.data.model);
                setRecordCount(_innerRes.data.itemsCount);
            } else if (_innerRes.data.itemsCount > 0) {
                setUserList(_innerRes.data.model);
                setRecordCount(_innerRes.data.itemsCount);
            } else if (_innerRes.data.itemsCount === 0) {
                setUserList([]);
                setRecordCount(_innerRes.data.itemsCount);
            }
        } else {
            setUserList([]);
        }
      } else {
          setUserList([]);
      }
      setLoading(false);  
    }, 200), [showAllUsers]);
    const getAllPCRs = async (updatePageNumber: any, keyword: string, sortOrder: any, sortColumn: any,status :any|null,startDay :any|null,endDay :any|null,customerids:any|null): Promise<void> => {
      setLoading(true);
      localStorage.setItem("ViewPCR:PageNumber",(updatePageNumber ? updatePageNumber-1 : page-1).toString());
      localStorage.setItem("ViewPCR:StartDate",startDay.toString());
      localStorage.setItem("ViewPCR:EndDate",endDay.toString());
      localStorage.setItem("ViewPCR:Keyword",keyword.toString());
      localStorage.setItem("ViewPCR:SortColumn",sortColumn.toString());
      localStorage.setItem("ViewPCR:SortDirection",sortOrder.toString());
      localStorage.setItem("ViewPCR:CurrentStatus",status!=null ? status : currentStatus);
      const _res = await api.searchPCRByNameCount('searchstr=' + keyword + '&pagenumber=' + (updatePageNumber ? updatePageNumber : page) + 
      '&pagesize=20&sortcolumn=' + sortColumn + '&sortdirection=' + sortOrder + `&showAll=${showAllUsers}` +
       '&startdate=' + format(startDay, "yyyy-MM-dd") + '&enddate=' + format(endDay, "yyyy-MM-dd")+
       "&version="+Math.random()+Math.random()+Math.random()+"&CustomerId="+customerids);
      if (_res !== null && _res.data !== null && _res.data.model !== null) {
          setCountReviewStatus((prevState) => ({
            ...prevState,
            countAll: _res.data.model.all,
            countNotApplicable: _res.data.model.notApplicable,
            countReviewPending: _res.data.model.reviewPending,
            countInReview: _res.data.model.inReview,
            countReviewed: _res.data.model.reviewed,
            countFlagged: _res.data.model.flagged,
            countPendingCGReview: _res.data.model.pendingCGReview,
            countInCGReview: _res.data.model.inCGReview,
            countCGReviewed: _res.data.model.cgReviewed,
            countCGFlagged: _res.data.model.cgFlagged,
          }));
          setReviewUser(_res.data.model.isReviewUser);
          if (status==1 || status==2 || status==5 || status==6){
            startDay=new Date();
            startDay.setFullYear(startDay.getFullYear() - 10);
            endDay=new Date();
            endDay.setFullYear(endDay.getFullYear() + 10);
          }
          const _innerRes = await api.searchPCRByName('searchstr=' + keyword + '&pagenumber=' + (updatePageNumber ? updatePageNumber : page) + 
          '&pagesize=20&sortcolumn=' + sortColumn + '&sortdirection=' + sortOrder + `&showAll=${showAllUsers}` +
           '&startdate=' + format(startDay, "yyyy-MM-dd") + '&enddate=' + format(endDay, "yyyy-MM-dd")+ 
           '&currentstatus=' + (status!=null ? status : currentStatus)+ 
           '&reviewuser=' +_res.data.model.isReviewUser+"&version="+Math.random()+Math.random()+Math.random()+"&CustomerId="+customerids);
          if (_innerRes !== null && _innerRes.data !== null && _innerRes.data.model !== null) {
            if (_innerRes.data.itemsCount > 0 && updatePageNumber >= page) {
                setUserList(_innerRes.data.model);
                setRecordCount(_innerRes.data.itemsCount);
            } else if (_innerRes.data.itemsCount > 0 && (page == 0 || page == 1)) {
                setUserList(_innerRes.data.model);
                setRecordCount(_innerRes.data.itemsCount);
            } else if (_innerRes.data.itemsCount > 0) {
                setUserList(_innerRes.data.model);
                setRecordCount(_innerRes.data.itemsCount);
            } else if (_innerRes.data.itemsCount === 0) {
                setUserList([]);
                setRecordCount(_innerRes.data.itemsCount);
            }
        } else {
            setUserList([]);
        }
      } else {
          setUserList([]);
      }
      setLoading(false);  
    };
  const editUserClick = (event: any, id: any) => {
    
    // if (id && reviewUser == true) {
    //   setSelected(id);
    //   var pageNumber = Number(page) + 1
    //   history.push({
    //     pathname: '/patientCareRecord/PCRObservationChartPDF/' + id,
    //   });
    // }
    if (id && reviewUser == true) {
      setSelected(id);
      var pageNumber = Number(page) + 1
      history.push({
        pathname: '/patientCareRecord/reviewpcr/' + id + '/' + pageNumber,
      });
    }

  };
    const downloadClick = async (event: any, id: any) => {
        if (id) { 


            setLoading(true)        
            const res = await api.downloadBookingPCR(`bookingid=${id}`,null);     
            if(res.hasError === false)
            {
              await api.downloadpcrfile('id=' + res.result ,null)
              .then((response) => {
                var pdf = res.result.replace(".pdf","-PCRPDF");
                window.open(response.result);
                //downloadPdf(response.result,pdf)
                setLoading(false)  
              })
              .catch((error) => {
                setLoading(false)  
                console.error(error);
              });
            }
            else{
              setLoading(false)  
              console.log('Download clicked!');
            }                          
        }
    };
    const downloadPdf = (base64String:any, fileName :any) => {

      const byteCharacters = atob(base64String);

      const byteNumbers = new Array(byteCharacters.length);

      for (let i = 0; i < byteCharacters.length; i++) {

        byteNumbers[i] = byteCharacters.charCodeAt(i);

      }

      const byteArray = new Uint8Array(byteNumbers);

 

      const pdfBlob = new Blob([byteArray], { type: 'application/pdf' });

      const pdfUrl = URL.createObjectURL(pdfBlob);

 
       //const link = document.createElement('a');
  
        //link.href = pdfUrl;
  
        //link.download = fileName;

        window.open(pdfUrl);
        //link.click();
  
        //URL.revokeObjectURL(pdfUrl);
  
    };

    const createSortHandler = (event: any, column: any) => {
        //console.log(column);
        let order_str = (orderBy == column ? (order === 'asc' ? 'desc' : 'asc') : 'asc');
        setOrder(order_str);
        setOrderBy(column);
    };

    const handleChangePage = (event: any, newPage: any) => {
        const updatePage = newPage + 1;
        setPage(newPage);
    };

    const inputChangedHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
        setSearchText(e.target.value);
        searchPCR(e.target.value);
    }

    const searchPCR = async (keyword: string): Promise<void> => {
      if (doLoad!=0){
        setPage(0);
      }
    }

    const searchUsersByEnter = async (event: any): Promise<void> => {
        if (event.key === 'Enter') {
            await searchPCR(searchText);
        }
    }

    const searchDatewisePCR = async (keyword: string): Promise<void> => {
        //setPage(0);
        //getAllPCR(0, keyword, order, orderBy);
    }

    const CreateLoadingLine = (props: any): JSX.Element => {
        const classes = useStyles();
        return (
            <div className={classes.loading} style={props.show ? { display: "" } : { visibility: "hidden" }}>
                <LinearProgress color="primary" />
            </div>
        );
    };

    const signOutUser = () => {
        const data = {"userId": signoutUserId}
        api.destroyUserVehicleSession('', data).then(res => {
            setSignoutDialog(false);
        })
    }

    const signoutClick = (e: any, userId: string) => {
        setSignoutDialog(true);
        setSignoutUserId(userId);
        e.stopPropagation();
    }
    const showCSVModalAction = async () => {
        setLoading(true);
        const filter = {        
        };
        const _res = await api.getTransferHistoryList("", filter);
        if (_res !== null && _res.data !== null && _res.data.model !== null && !_res.data.hasError) {
          columnList[1](_res.data.model.transferExportFields.exportColumns);
          setSaveSelection(_res.data.model.transferExportFields.saveSelection);
        }
        setShowDownloadCSVModal(true);
        setLoading(false);
      };
    const saveTransferExportData = () => {
        api.saveTransferExportUserSelection("", {
          selectedColumns: columnList[0].filter((item) => item.selected).map((item) => item.columnName),
          saveSelection: true,
        });
      };
  function StyledCheckbox(props: CheckboxProps) {
        const classes = useStylesCheckBox();
      
        return (
          <Checkbox
            className={classes.root}
            disableRipple
            color="default"
            checkedIcon={<span className={clsx(classes.icon, classes.checkedIcon)} />}
            icon={<span className={classes.icon} />}
            inputProps={{ "aria-label": "decorative checkbox" }}
            {...props}
          />
        );
      }
      
const PopupDownloadCol = ({ closeModalAction, isModalOpen, columnList, csvReport, saveTransferExportData, saveSelection, setSaveSelection }: any) => {
        const [searchText, setSearchText] = React.useState("");
        const classes = useStyles();
      
        return (
          <Dialog
            open={isModalOpen}
            PaperProps={{
              style: {
                backgroundColor: "#FFF",
              },
            }}
            onClose={closeModalAction}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            maxWidth="xs"
          >
            <DialogContent className={classes.dialogContent}>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <Typography style={{ color: "#14191C", fontWeight: 400, fontSize: 19 }} gutterBottom>
                  Choose fields for export
                </Typography>
                <IconButton onClick={closeModalAction} aria-label="close">
                  <CloseIcon style={{ color: "#000" }} />
                </IconButton>
              </div>
              <TextField
                id="filled-start-adornment"
                size="small"
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <SearchIcon style={{ color: "#707070" }} />
                    </InputAdornment>
                  ),
                  style: { backgroundColor: "#ECECEC" },
                }}
                variant="outlined"
                value={searchText}
                onChange={(e) => setSearchText(e.target.value)}
                autoComplete="off"
              />
            </DialogContent>
            <div style={{ height: 1, backgroundColor: "#979797" }}></div>
            <DialogContent
              style={{
                width: 360,
                display: "flex",
                justifyContent: "center",
                flexDirection: "column",
              }}
            >
              <div
                style={{
                  display: "flex",
                  height: 300,
                  flexDirection: "column",
                }}
              >
                {columnList[0].map((item: any) => {
                  if (
                    searchText == "" ||
                    (item.columnCaption?.indexOf(searchText) != undefined && item.columnCaption?.toLowerCase().indexOf(searchText.toLowerCase()) >= 0)
                  ) {
                    return (
                      <Typography key={item.columnName} variant="h6" style={{ color: "#14191C", fontWeight: 400, fontSize: 19 }} gutterBottom>
                        <StyledCheckbox
                          onClick={() =>
                            columnList[1]((previousState: any[]) =>
                              previousState.map((i: any) => (i.columnName == item.columnName ? { ...i, selected: !i.selected } : i))
                            )
                          }
                          checked={item.selected}
                        />
                        {item.columnCaption}
                      </Typography>
                    );
                  } else {
                    return null;
                  }
                })}
              </div>
            </DialogContent>
            <div style={{ height: 1, backgroundColor: "#979797" }}></div>
            <DialogContent
              style={{
                width: 360,
                display: "flex",
                justifyContent: "center",
                flexDirection: "column",
                paddingTop: 0,
                paddingBottom: 0,
                marginTop: "0.35em",
              }}
            >
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                <Typography variant="h6" style={{ color: "#14191C", fontWeight: 400, fontSize: 19 }} gutterBottom>
                  <StyledCheckbox onClick={() => setSaveSelection((prev: any) => !prev)} checked={saveSelection} />
                  Save my selection
                </Typography>
              </div>
            </DialogContent>
      
            <div style={{ height: 1, backgroundColor: "#979797" }}></div>
            <DialogContent
              style={{
                width: 360,
                display: "flex",
                justifyContent: "center",
                flexDirection: "column",
                overflow: "hidden",
              }}
            >
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  marginBottom: 15,
                  marginTop: 15,
                }}
              >
                <Button className={classes.popupCancel} variant="contained" color="primary" disableElevation onClick={closeModalAction}>
                  Cancel
                </Button>
                {csvReport.data.length > 0 && (
                  <CSVLink
                    {...csvReport}
                    onClick={(event: any, done: any) => {
                      if (csvReport.data.length > 0) return true;
                      return false;
                    }}
                  >
                    <Button
                      className={classes.popupApply}
                      variant="contained"
                      color="primary"
                      disableElevation
                      onClick={() => {
                        closeModalAction();
                        if (saveSelection) {
                          saveTransferExportData();
                        } else {
                          setTimeout(() => {
                            columnList[1]((prev: any) => {
                              return prev.map((item: any) => ({ ...item, selected: false }));
                            });
                          }, 0);
                        }
                      }}
                    >
                      Download
                    </Button>
                  </CSVLink>
                )}
              </div>
            </DialogContent>
          </Dialog>
        );
    };
    function NavRightMenu(props: any): JSX.Element {
        return (
            <Button onClick={props.rightButtonClick} endIcon={<KeyboardArrowDownIcon />} style={{ color: "#FFF" }}>
                {props.userName}
            </Button>
        );
    }
    function PCRReviewStatusString(object: PCRReviewStatus): string {
      switch (object) {
        case PCRReviewStatus.NotApplicable:
          return 'N/A';
        case PCRReviewStatus.ReviewPending:
          return 'Pending Review';
        case PCRReviewStatus.InReview:
          return 'In Review';
        case PCRReviewStatus.Reviewed:
          return 'Reviewed';
        case PCRReviewStatus.Flagged:
            return 'Flagged';
        case PCRReviewStatus.PendingCGReview:
          return 'Pending CG Review';
        case PCRReviewStatus.InCGReview:
            return 'In CG Review';
        case PCRReviewStatus.CGReviewed:
              return 'CG Reviewed';
        case PCRReviewStatus.CGFlagged:
          return 'CG Flagged';
        default:
          return 'N/A';
      }
    }

    const [text, settext] = React.useState(localStorage.getItem("ViewPCR:Keyword")!=null ? localStorage.getItem("ViewPCR:Keyword") : "");

    React.useEffect(() => {
        setLoading(true);
        searchPCR(text ?? "");
    }, [text]);
    
    return (
        <React.Fragment>
          <MuiThemeProvider theme={theme}>
            {authStore?.data?.IsAdmin ? (
            <Navbar rightButton={<NavRightMenu userName={authStore?.data?.givenName ?? ""} />} />
            ) : (
            <Navbar rightButton={<NavRightMenu userName={authStore?.data?.givenName ?? ""} />} />
            )}
            {show.subHeader && (
            <div style={loading ? { pointerEvents: "none", opacity: "0.4" } : {}}>
                <SubHeader
                    show={show}
                    title={selectedCustomer}
                   leftButtonClick={() => popState[1](true)}
                    settext={settext}
                    otherProps={{ onSearchTextChange: setSearchKey, endDay, startDay, dateDialog, setEndDay, setStartDay, setDateDialog, showCSVModalAction, loading, currentStatus, searchKey }}
                />
            </div>
            )}
            <Paper
              style={{ height: "100$", paddingBottom: 100, borderRadius: 0 }}
              elevation={0}
            >
              {loading && (<>
              <div style={{ marginTop: 0, marginBottom: 0 }}>
                <CreateLoadingLine show={loading} />
              </div>
              </>)}
              {reviewUser==true && <>
              <Grid container className={classes.tabFilters} spacing={0}>
                <Grid item>
                  <Button onClick={() => setCurrentStatus(PCRReviewStatus.All)} className={currentStatus==PCRReviewStatus.All ? `btnFilter active` : `btnFilter`} >All ({countReviewStatus?.countAll})</Button>
                  <Button onClick={() => setCurrentStatus(PCRReviewStatus.NotApplicable)} className={currentStatus==PCRReviewStatus.NotApplicable ? `btnFilter active` : `btnFilter`}>Not Marked For Review ({countReviewStatus?.countNotApplicable})</Button>
                  <Button onClick={() => setCurrentStatus(PCRReviewStatus.Reviewed)} className={currentStatus==PCRReviewStatus.Reviewed ? `btnFilter active` : `btnFilter`}>Reviewed ({countReviewStatus?.countReviewed})</Button>
                  <Button onClick={() => setCurrentStatus(PCRReviewStatus.Flagged)} className={currentStatus==PCRReviewStatus.Flagged ? `btnFilter active` : `btnFilter`}>Flagged ({countReviewStatus?.countFlagged})</Button>
                  <Button onClick={() => setCurrentStatus(PCRReviewStatus.CGReviewed)} className={currentStatus==PCRReviewStatus.CGReviewed ? `btnFilter active` : `btnFilter`}>CG Reviewed ({countReviewStatus?.countCGReviewed})</Button>
                  <Button onClick={() => setCurrentStatus(PCRReviewStatus.CGFlagged)} className={currentStatus==PCRReviewStatus.CGFlagged ? `btnFilter active` : `btnFilter`}>CG Flagged ({countReviewStatus?.countCGFlagged})</Button>
                </Grid>
                <Grid item>
                  <Button onClick={() => setCurrentStatus(PCRReviewStatus.ReviewPending)} className={currentStatus==PCRReviewStatus.ReviewPending ? `btnFilter active` : `btnFilter`}>Pending Review ({countReviewStatus?.countReviewPending})</Button>
                  <Button onClick={() => setCurrentStatus(PCRReviewStatus.InReview)} className={currentStatus==PCRReviewStatus.InReview ? `btnFilter active` : `btnFilter`}>In Review ({countReviewStatus?.countInReview})</Button>
                  <Button onClick={() => setCurrentStatus(PCRReviewStatus.PendingCGReview)} className={currentStatus==PCRReviewStatus.PendingCGReview ? `btnFilter active` : `btnFilter`}>Pending CG Review ({countReviewStatus?.countPendingCGReview})</Button>
                  <Button onClick={() => setCurrentStatus(PCRReviewStatus.InCGReview)} className={currentStatus==PCRReviewStatus.InCGReview ? `btnFilter active` : `btnFilter`}>In CG Review ({countReviewStatus?.countInCGReview})</Button>
                </Grid>
              </Grid>
              </>}

              <Table className={classes.table}>
                <TableRow>
                  <TableCell
                    style={{
                      paddingBottom: 5,
                      paddingTop: 5,
                      paddingLeft: 0,
                      paddingRight: 0,
                      borderBottom: "none",
                    }}
                    colSpan={0}
                  >
                    <Box margin={0} style={loading ? { pointerEvents: "none", opacity: "0.4" } : {}}>
                      <Table size="small" aria-label="pcrTable" style={{ tableLayout: "fixed" }}>
                        <TableHead>
                          <TableRow className={classes.tableHead}>
                            {headCells.map((headCell) => (
                            <TableCell
                              key={headCell.id}
                              align={headCell.numeric ? 'right' : 'left'}
                              width={headCell.width}
                              //sortDirection={orderBy === headCell.id ? 'asc' : false}
                            >
                              {headCell.id ? headCell.label : null}
                              {headCell.id=="CreatedOn" && (<>
                                {" "}
                                <IconButton
                                  classes={{ root: classes.buttonRoot }}
                                  onClick={(e => createSortHandler(e, headCell.id))}
                                >
                                  <KeyboardArrowDownIcon
                                    style={{
                                      padding: 0,
                                      marginBottom: 0,
                                      ...(orderBy === headCell.id ? (order === 'asc' ? {} : { transform: "rotate(180deg)" }) : {}),
                                    }}
                                  />
                                </IconButton>
                              </>)}
                            </TableCell>
                            ))}
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {userList.map((row, index) => {
                            return (
                              <TableRow
                                  onClick={(event) => editUserClick(event, row.id)}
                                  hover
                                  key={row.id}
                                  className={classes.tableBody}
                                >
                                  <TableCell className={classes.tableCell}>
                                    {format( new Date(row.createdOn), "dd/MM/yyyy HH:mm")}
                                  </TableCell>
                                  <TableCell className={classes.tableCell}>{row.pcrType == "1" ? "Medical Incident" : row.pcrType == "2" ? "Patient Transport" : "Patient Transport With Incident Medical Incident En Route"}</TableCell>
                                  <TableCell className={classes.tableCell}>{row.surName}</TableCell>
                                  <TableCell className={classes.tableCell}>{row.givenName}</TableCell>
                                  <TableCell className={classes.tableCell}>{format( new Date(row.dob), "dd/MM/yyyy")}</TableCell>
                                  {/* <TableCell className={classes.tableCell}>{row.gender == "1"?"Male":row.gender == "2"?"Female":row.gender == "3"?"Other":"Unspecified"}</TableCell> */}
                                  <TableCell className={classes.tableCell}>{row.gender}</TableCell>                                         
                                  <TableCell className={classes.tableCell}>{row.mrn}</TableCell>
                                  {reviewUser==true && <TableCell className={classes.tableCell}>{row.reviewStatus}</TableCell>}
                                  {reviewUser == false && <TableCell className={classes.tableCell}>
                                    <div style={{ alignSelf: "flex-end", marginRight: 30 }} onClick={(event: any) => downloadClick(event, row.id)}>  <CloudDownloadIcon style={{ width: 24, height: 24, cursor: "pointer", color: "#000" }}  /></div>
                                  </TableCell>}
                              </TableRow>
                            );
                          })}
                        </TableBody>
                      </Table>
                      {userList.length <= 0 && <div style={{ display: "flex", justifyContent: "center" }}>No Records found</div>}
                    </Box>
                    </TableCell>
                </TableRow>
              </Table>
              <TablePagination
                rowsPerPageOptions={[20]}
                component="div"
                count={recordCount}
                rowsPerPage={rowsPerPage}
                page={page}
                onChangePage={handleChangePage}
                style={loading ? { pointerEvents: "none", opacity: "0.4" } : {}}
              />
            </Paper>
          </MuiThemeProvider>
          <CustomerPopup popState={popState} filterCustomer={filterCustomer} customerState={customerState} />                    
          <PopupDownloadCol
            closeModalAction={() => setShowDownloadCSVModal(false)}
            isModalOpen={showDownloadCSVModal}
            columnList={columnList}
            csvReport={csvReport}
            saveTransferExportData={saveTransferExportData}
            saveSelection={saveSelection}
            setSaveSelection={setSaveSelection}
          />
          <Dialog onClose={() => setDateDialog(null)} open={dateDialog != null}>
            <MuiPickersUtilsProvider utils={DateFnsUtils}>
              <KeyboardDatePicker
                variant="static"
                format="d MMM yyyy"
                value={dateDialog == "endDay" ? endDay : startDay}
                onChange={handlePickerDateChange}
              />
            </MuiPickersUtilsProvider>
          </Dialog>
          <SignOutUserDialog isDialogOpen={signoutDialog} onCancel={setSignoutDialog} onClickFunc={signOutUser} popupMessage={"Do you want to signout this user?"} />                            
        </React.Fragment>
    );
}

export default React.memo(ViewPCRWidget);